<template>
    <div>
        <div v-if="providers == null">
            {{translate('loading')}}
        </div>
        <div v-else-if="providers.length == 0" class="alert alert-warning">
            <h5>{{translate('remInboxList.kepIncomingBox')}}</h5>
            {{translate('warnings.noDefinedKepAccount')}}
        </div>
        <div v-else class="row">
            <div style="width: 200px;">
                <div style="margin-bottom:20px;">
                    <!-- <select class="form-control" v-model="selectedProviderId" @change="selectedProviderChanged">
                        <option v-for="p in providers" :key="p.Id" :value="p.Id">
                            {{p.RemAddress}}
                        </option>
                    </select> -->

                    <select-input v-if="providers"
                        :items="providers"
                        style=""
                        v-model="selectedProvider"
                        @change="selectedProviderChanged"
                        >
                        <span v-if="selectedProvider" :key="selectedProvider.Id">
                            <img :src="'/img/' + selectedProvider.Kind + '.png'" class="rem-icon">
                            {{ selectedProvider.RemAddress }}
                        </span>
                        <template v-slot:item="{ item }">
                            <img :src="'/img/' + item.Kind + '.png'" class="rem-icon">
                            {{ item.RemAddress }}
                        </template>
                    </select-input>
                </div>
                <div class="">
                    <rem-refresh v-if="hasModule('REMManagement')" ref="remRefreshComponent" @completed="remSynchCompleted" :providerId="selectedProvider.Id" folder="Inbox" style="margin-bottom:20px;" />
                    <ul class="list-group list-group-flush">
                        <router-link :to="{ name: 'RemInbox', params: { provider: selectedProvider.Id } }" class="list-group-item list-group-item-action">
                            {{translate('inbox')}}
                        </router-link>
                        <router-link :to="{ name: 'RemOutbox', params: { provider: selectedProvider.Id } }" class="list-group-item list-group-item-action">
                            {{translate('outbox')}}
                        </router-link>
                        <router-link :to="{ name: 'RemList' }" exact class="list-group-item list-group-item-action d-flex justify-content-between align-items-center">{{translate('remInboxList.jobsToSend')}}<span class="badge badge-primary badge-pill" v-if="selectedProviderStats">{{selectedProviderStats.Waiting}}</span> </router-link>
                        <router-link :to="{ name: 'RemNewMessage', params: { provider: selectedProvider.Id, id: '000000000000000000000000' } }" exact class="list-group-item list-group-item-action ">{{translate('remInboxList.sendNew')}}</router-link>
                        <router-link :to="{ name: 'RemDraft', params: { provider: selectedProvider.Id } }" exact class="list-group-item list-group-item-action ">{{translate('remDraftList.drafts')}}</router-link>
                    </ul>
                </div>
            </div>
            <div class="col">
                <router-view :key="viewKey"  @onload="refreshStats"></router-view>
            </div>
        </div>
    </div>
</template>
<script>
import dataMixin from '../dataMixin.js'
import remRefresh from '../components/RemRefresh.vue'
import selectInput from "../components/SelectInput.vue";


export default {
    components: {
        remRefresh,
        selectInput
    },
    mixins: [dataMixin],
    data(){
        return {
            providers: null,
            selectedProviderStats: null,
            selectedProvider: null,
            viewKey: null
        }
    },
    created(){
        this.getRemProviders()
        .then(x => {
            console.log('Providers: ', x.Result);
            this.providers = x.Result;

            if(this.providers && this.providers.length > 0) {
                if(this.$route.params.provider) {
                    this.selectedProvider = this.providers.filter(x => x.Id == this.$route.params.provider)[0];
                } else {
                    this.selectedProvider = this.providers[0];
                }
            }

            if(this.selectedProvider) {
                this.viewKey = new Date().valueOf();
                this.refreshStats();
            }
        })
    },
    methods: {
        selectedProviderChanged(provider){
            console.log('SelectedProviderChanged: ', provider);
            this.selectedProvider = provider;
            if(this.hasModule('REMManagement')) {
                this.$router.push({  params: { provider: provider.Id } });
                this.refreshStats();
            }

            this.reloadView();
        },
        remSynchCompleted(){
            console.log('RemSyncCompleted route name: ', this.$route.name);
            this.reloadView();
        },
        refreshStats(){  
            if(this.selectedProvider) {
                this.getRemProviderStats(this.selectedProvider.Id).then(x => {
                    this.selectedProviderStats = x.Data;
                });
            }
        },
        reloadView(){
            if(this.$route.name == 'RemInbox' || this.$route.name == 'RemOutbox' || this.$route.name == 'RemOutboxDetail')
                this.viewKey = new Date().valueOf();
        }
    }
    // computed: {
    //     selectedProvider(){
    //         return this.providers?.filter(x => x.Id == this.selectedProviderId)[0];
    //     }
    // }
}
</script>
<style scoped>
.rem-icon {
    width:18px;
    height: 18px;
    margin-right: 6px;
}
</style>